document.addEventListener("DOMContentLoaded", function () {

/* -----------------------------
FORMAT
----------------------------- */
function formatMoney(num){
  return "₹" + Number(num).toLocaleString("en-IN")
}

/* -----------------------------
BASE PRICE
----------------------------- */
let basePrice = parseInt(
document.getElementById("yumiBasePrice")?.dataset.price || 0
)

/* -----------------------------
BAG TAG FORM MEMORY
----------------------------- */
let bagTagFormData = {
  name: "",
  class: "",
  contact: "",
  blood: ""
}

/* -----------------------------
UPDATE TOTAL
----------------------------- */
function updateTotal(){

let addonTotal = 0

document.querySelectorAll(".yumi-addon-card").forEach(card => {

let checkbox = card.querySelector(".addon-checkbox")
if (!checkbox || !checkbox.checked) return

let price = parseInt(checkbox.dataset.basePrice || 0)

// ANY RADIO (Character / Sticker / Bag Tag)
let selected = card.querySelector("input[type='radio']:checked")
if (selected){
price = parseInt(selected.dataset.price || 0)
}

addonTotal += price

})

document.getElementById("yumiAddonPrice").innerText =
formatMoney(addonTotal)

document.getElementById("yumiFinalPrice").innerText =
formatMoney(basePrice + addonTotal)

}

/* -----------------------------
CHECKBOX
----------------------------- */
document.addEventListener("change", function(e){

if(e.target.classList.contains("addon-checkbox")){

let card = e.target.closest(".yumi-addon-card")

// toggle active state
card.classList.toggle("active", e.target.checked)


updateTotal()

}

})

/* -----------------------------
GLOBAL RADIO SELECT (FIXED)
----------------------------- */
document.addEventListener("change", function(e){

if(e.target.type === "radio"){

let card = e.target.closest(".yumi-addon-card")

// uncheck others in same card
card.querySelectorAll("input[type='radio']").forEach(r=>{
  if(r !== e.target) r.checked = false
})

// update selected text
let display = card.querySelector(".selected-value")

if(display){
display.innerText =
e.target.dataset.name + " (₹" +
Number(e.target.dataset.price).toLocaleString("en-IN") + ")"

display.parentElement.style.display = "flex"
}

updateTotal()

}

})

/* -----------------------------
REMOVE SELECTION
----------------------------- */
document.addEventListener("click", function(e){

if(e.target.classList.contains("remove-selection")){

let card = e.target.closest(".yumi-addon-card")

card.querySelectorAll("input[type=radio]").forEach(r=>r.checked=false)

let display = card.querySelector(".selected-value")
if(display){
display.innerText = ""
display.parentElement.style.display = "none"
}

updateTotal()

}

})

/* -----------------------------
BAG TAG FLOW
----------------------------- */

// COLLECTION CLICK
document.querySelectorAll(".bagtag-collection-item").forEach(item=>{
item.addEventListener("click", function(){

let handle = this.dataset.handle
let container = document.querySelector(".bagtag-variants")
let collections = document.querySelector(".bagtag-collections")
let backBtn = document.querySelector(".bagtag-back-btn")

container.innerHTML = ""
collections.style.display = "none"
container.style.display = "flex"

if(backBtn){
backBtn.style.display = "block"
}

window.bagTagData[handle].forEach(v=>{
container.innerHTML += `
<label class="addon-thumb">
<input type="radio" class="bagtag-radio"
data-id="${v.id}"
data-name="${v.name}"
data-price="${v.price}">
<img src="${v.image}">
<span>${v.name}</span>
<small style="display:block;font-size:12px;color:#777;">
₹${Number(v.price).toLocaleString("en-IN")}
</small>
</label>
`
})

})
})

// BACK BUTTON
document.querySelector(".bagtag-back-btn")?.addEventListener("click", function(){

document.querySelector(".bagtag-variants").style.display = "none"
document.querySelector(".bagtag-collections").style.display = "flex"

this.style.display = "none"

})

/* -----------------------------
BAG TAG FORM MEMORY
----------------------------- */
document.addEventListener("input", function(e){

if(e.target.closest(".yumi-bagtag-popup")){

if(e.target.name.includes("Name")){
  bagTagFormData.name = e.target.value
}
if(e.target.name.includes("Class")){
  bagTagFormData.class = e.target.value
}
if(e.target.name.includes("Contact")){
  bagTagFormData.contact = e.target.value
}
if(e.target.name.includes("Blood")){
  bagTagFormData.blood = e.target.value
}

}

})

/* -----------------------------
PRINT OPTION → POPUP
----------------------------- */
document.querySelector(".bagtag-print-option")?.addEventListener("change", function(){

let popup = document.querySelector(".yumi-bagtag-popup")

if(this.value === "yes"){

popup.classList.add("active")

popup.querySelector('[name="properties[Bag Tag Name]"]').value = bagTagFormData.name
popup.querySelector('[name="properties[Bag Tag Class]"]').value = bagTagFormData.class
popup.querySelector('[name="properties[Bag Tag Contact]"]').value = bagTagFormData.contact
popup.querySelector('[name="properties[Bag Tag Blood Group]"]').value = bagTagFormData.blood

} else {
popup.classList.remove("active")
}

})

/* -----------------------------
POPUP VALIDATION
----------------------------- */
document.querySelector(".yumi-popup-save")?.addEventListener("click", function(){

let name = document.querySelector('[name="properties[Bag Tag Name]"]')?.value.trim()
let contact = document.querySelector('[name="properties[Bag Tag Contact]"]')?.value.trim()

if(!name){
  alert("Please enter Name")
  return
}

if(!contact){
  alert("Please enter Emergency Contact")
  return
}

this.closest(".yumi-bagtag-popup").classList.remove("active")

})

/* -----------------------------
POPUP CLOSE
----------------------------- */
document.querySelectorAll(".yumi-popup-close").forEach(btn=>{
btn.addEventListener("click", function(){
this.closest(".yumi-bagtag-popup").classList.remove("active")
})
})

/* -----------------------------
INIT
----------------------------- */
updateTotal()

})


